import styled from "styled-components";

export const CheckboxLine = styled.span`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const CheckboxLabelMode = styled.span`
  font-size: 12px;
  font-weight: 600;
  width: 30px;
  visibility: hidden;
`;

export const CheckboxLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  gap: 5px;

  &:hover ${CheckboxLabelMode} {
    visibility: visible;
  }
`;

export const CheckboxLabelValue = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CheckboxLabelEmpty = styled.span`
  font-style: italic;
`;

export const CheckboxLabelCount = styled.span`
  width: 40px;
  text-align: right;
  color: dimgrey;
`;

export const CheckboxLabelGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
